import React from 'react'
import plyr from 'plyr'
import 'plyr/dist/plyr.css'

const Hls = window.Hls

class VideoPlayer extends React.Component {

  componentDidMount() {
    // instantiate plyr + hls

    const hlsConfig = {
      fragLoadingTimeOut: 50000,
      manifestLoadingTimeOut: 25000,
      levelLoadingTimeOut: 10000,
      capLevelToPlayerSize: true,
      enableWorker: false,
    }

    console.log(this.props);

    console.log(this.props.sources[0].provider);
    var players = null;
    if (this.props.sources[0].provider && this.props.sources[0].provider === 'youtube') {
      players = plyr.setup('#plyr-player')
      
    } else {
      if (Hls.isSupported()) {
        console.log('Hls is supported')
        if (this.videoNode) {

          console.log('this.props.sources[0].src:' + this.props.sources[0].src)

          const hls = new Hls(hlsConfig)
          // hls.loadSource('http://qthttp.apple.com.edgesuite.net/1010qwoeiuryfg/sl.m3u8')
          hls.loadSource(this.props.sources[0].src)
          hls.attachMedia(this.videoNode)
          hls.on(Hls.Events.MEDIA_ATTACHED, () => {
            console.log('video and hls.js are now bound together')
          })
          hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
            console.log("manifest loaded, levels:" + data.levels.length)
            // that.videoNode.play()
          })
          hls.on(Hls.Events.ERROR, (event, data) => {
            // console.log('Hls.Events.ERROR: data:' + data + 'event:' + event)
            console.log(`errorType: ${data.type}, errorDetails: ${data.details}, errorFatal: ${data.fatal}`)

            console.log(JSON.stringify(event))

            console.log(data.type);
            console.log(data.details);
            if (data.fatal) {
              switch (data.type) {
                case Hls.ErrorTypes.NETWORK_ERROR:
                  // try to recover network error
                  console.log("fatal network error encountered, try to recover");
                  hls.startLoad();
                  break;
                case Hls.ErrorTypes.MEDIA_ERROR:
                  console.log("fatal media error encountered, try to recover");
                  hls.recoverMediaError();
                  break;
                default:
                  // cannot recover
                  hls.destroy();
                  break;
              }
            }
          })
          console.log(this.videoNode);
        }
        else {
          console.log('videoNode not found')
        }

        players = plyr.setup('#plyr-player', {
          ...this.props
        })
      }
      else {
        console.log('Video is not supported on your device')
      }
    }

    if (players) {
      const player = players[0]
      this.props.onPlayerReady(player, this.props.context);
    }
  }

  youtube_parser(url) {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11) ? match[7] : false;
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose()
    }
  }

  render() {
    return (
      <div className="video-player">
        {this.props.sources[0].provider && this.props.sources[0].provider === 'youtube' ?
          (<div id="plyr-player" data-plyr-provider="youtube" data-plyr-embed-id={this.youtube_parser(this.props.sources[0].src)}></div>) :
          (<video ref={node => this.videoNode = node} preload="none" id="plyr-player"></video>)}
      </div>
    )
  }
}

export default VideoPlayer
